const { ERP_URL } = require("./config");
const { parse } = require("node-html-parser");
const constants = require("./config");

const execute = async (name: string, args: any = {}, props: any = {}) => {
  if (Object.keys(constants).indexOf(name) == -1) {
    throw `Function ${name} not registered`;
  }
  const _props = {
    secure: props.secure != null ? props.secure : true,
    jsonify: props.jsonify != null ? props.jsonify : true,
    as_url: props.as_url != null ? props.as_url : false,
    root: props.root != null ? props.root : false,
    log: props.log != null ? props.log : false,
    status: props.status != null ? props.status : false,
    catch: props.catch != null ? props.catch : false,
  };

  let url = `${ERP_URL}?cmd=${constants[name]}`; //preparing url for request
  let response: any;
  try {
    if (_props.as_url) {
      url +=
        "&" +
        Object.keys(args)
          .map((arg) => `${arg}=${encodeURIComponent(args[arg])}`)
          .join("&");
      response = await fetch(url, {
        credentials: "include",
      });
    } else {
      response = await fetch(`${ERP_URL}/api/method/${constants[name]}`, {
        headers: _props.secure
          ? {
              // Authorization: `token ${process.env.REACT_APP_ERP_API_KEY}`,
              "Content-Type": "application/json",
              Accept: "text/html",
              "X-React-Login": "true"
              // "Access-Control-Allow-Origin": "*",
            }
          : {},
        body: JSON.stringify(args),
        method: "POST",
        credentials: "include",
      });
    }
    let result: any = await response.text();

    try {
      if (_props.jsonify) {
        result = JSON.parse(result);

        if (result.exc != null) {
          const exc = JSON.parse(result.exc);
          throw Error(exc[0] || exc);
        }
      }
    } catch (ex) {
      if (result.toString().indexOf("frappe") !== -1) {
        const _result = parse(result);
        let text = "";
        try {
          const element = _result.querySelector(".page-card-body pre");
          text = element.text.trim();
        } catch (e) {
          try {
            text = _result.querySelector(".page-card-body").text.trim();
          } catch (e) {
            text = "";
          }
        }
        _props.log && console.dir(text, { depth: null });
        throw Error(text);
      } else {
        const _result = parse(result);
        _props.log &&
          console.log(
            "Something went wrong, it might have to do with the server being offline or restarting...."
          );
        throw ex;
      }
    }
    if (_props.status) {
      return {
        status: response.status,
        data: _props.jsonify ? (_props.root ? result : result.message) : result,
      };
    } else {
      return _props.jsonify ? (_props.root ? result : result.message) : result;
    }
  } catch (e) {
    if (_props.catch) {
      return { status: response.status, error: e };
    } else {
      throw e;
    }
  }
};

export default execute;
